import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";
import {
  undoAtom,
  hasExpandedZapNodesAtom,
  saveCanvasAsyncCommand,
} from "@zapier/canvas-state";

import styles from "./AutoLayoutSuccessMessage.module.css";

type Props = {
  isMultiSelect?: boolean;
  hasExpandedSelectedZapNodes?: boolean;
};

export default function AutoLayoutSuccessMessage({
  isMultiSelect = false,
  hasExpandedSelectedZapNodes,
}: Props) {
  const undo = useSetAtom(undoAtom);
  const saveToBackend = useSetAtom(saveCanvasAsyncCommand);
  const hasExpandedZapNodes = useAtomValue(hasExpandedZapNodesAtom);

  const handleUndo = useCallback(async () => {
    const pastState = undo();
    if (pastState) {
      saveToBackend(pastState);
    }
  }, [undo, saveToBackend]);

  function getMessage() {
    if (isMultiSelect) {
      if (hasExpandedSelectedZapNodes) {
        return "Layout formatted! You can also try hiding your Zap steps.";
      }
      return "Layout formatted!";
    }

    if (hasExpandedZapNodes) {
      return "Layout formatted! You can also try hiding your Zap steps.";
    }
    return "Layout formatted!";
  }

  return (
    <div>
      <span className={styles.successMessage}>
        {getMessage()}
        <button className={styles.undoButton} onClick={handleUndo}>
          Undo
        </button>
      </span>
      <div>
        <strong>Tip</strong>: You can also use{" "}
        <>
          <span className={styles.key}>⌘ Command</span> +{" "}
          <span className={styles.key}>Z</span>
        </>{" "}
        to undo.
      </div>
    </div>
  );
}
